import { FC, useRef } from 'react'

import { Box, BoxProps } from '@mui/material'

import logoIcon from '../../../assets/img/logo.svg'

type OwnProps = {
  styles: string
}

export const ScreenWrapper: FC<OwnProps & BoxProps> = ({
  children,
  styles,
  ...rest
}) => {
  const ref = useRef<HTMLElement>()

  return (
    <Box
      ref={ref}
      className={styles}
      sx={{
        display: 'flex',
        alignItems: 'center',
        flexDirection: {
          xs: 'column',
        },
        py: {
          xs: 12,
          md: 12,
        },
      }}
      {...rest}
    >
      <Box component="img" mb={4} src={logoIcon} sx={{ height: 48, flex: '0 0' }} />
      {children}
    </Box>
  )
}
